import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aK3FG"), parcelRequire.load("9f8mp"), parcelRequire.load("bWofC")]).then(() => {
  return Promise.all([waitForCSS("https://reactspectrum.blob.core.windows.net/reactspectrum/a4c749335381c6b589f338131bbacbb249824629/s2-docs/error.98a5aa97.css")]);
}).then(() => {
let originalModule = parcelRequire("lVVdJ");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aK3FG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("bWofC")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
